/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContributionSummaryViewModel
 */
export interface ContributionSummaryViewModel {
    /**
     * 
     * @type {string}
     * @memberof ContributionSummaryViewModel
     */
    currentTaxYear?: string;
    /**
     * 
     * @type {number}
     * @memberof ContributionSummaryViewModel
     */
    contributionsReceivedInCurrentTaxYear?: number;
    /**
     * 
     * @type {number}
     * @memberof ContributionSummaryViewModel
     */
    balanceOfContributionsAllowedInCurrentTaxYear?: number;
    /**
     * 
     * @type {number}
     * @memberof ContributionSummaryViewModel
     */
    lifetimeContributionsReceived?: number;
    /**
     * 
     * @type {number}
     * @memberof ContributionSummaryViewModel
     */
    balanceOfLifetimeContributionsAllowedInCurrentTaxYear?: number;
}

/**
 * Check if a given object implements the ContributionSummaryViewModel interface.
 */
export function instanceOfContributionSummaryViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContributionSummaryViewModelFromJSON(json: any): ContributionSummaryViewModel {
    return ContributionSummaryViewModelFromJSONTyped(json, false);
}

export function ContributionSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContributionSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentTaxYear': !exists(json, 'CurrentTaxYear') ? undefined : json['CurrentTaxYear'],
        'contributionsReceivedInCurrentTaxYear': !exists(json, 'ContributionsReceivedInCurrentTaxYear') ? undefined : json['ContributionsReceivedInCurrentTaxYear'],
        'balanceOfContributionsAllowedInCurrentTaxYear': !exists(json, 'BalanceOfContributionsAllowedInCurrentTaxYear') ? undefined : json['BalanceOfContributionsAllowedInCurrentTaxYear'],
        'lifetimeContributionsReceived': !exists(json, 'LifetimeContributionsReceived') ? undefined : json['LifetimeContributionsReceived'],
        'balanceOfLifetimeContributionsAllowedInCurrentTaxYear': !exists(json, 'BalanceOfLifetimeContributionsAllowedInCurrentTaxYear') ? undefined : json['BalanceOfLifetimeContributionsAllowedInCurrentTaxYear'],
    };
}

export function ContributionSummaryViewModelToJSON(value?: ContributionSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CurrentTaxYear': value.currentTaxYear,
        'ContributionsReceivedInCurrentTaxYear': value.contributionsReceivedInCurrentTaxYear,
        'BalanceOfContributionsAllowedInCurrentTaxYear': value.balanceOfContributionsAllowedInCurrentTaxYear,
        'LifetimeContributionsReceived': value.lifetimeContributionsReceived,
        'BalanceOfLifetimeContributionsAllowedInCurrentTaxYear': value.balanceOfLifetimeContributionsAllowedInCurrentTaxYear,
    };
}

